import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.match.js";
export default (function () {
  return (// 微信小程序
    navigator.userAgent.match(/micromessenger/i) && navigator.userAgent.match(/miniprogram/i) || window.__wxjs_environment === 'miniprogram'
  );
});